import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthNavigation } from '../features/auth';
import { MapNavigation } from '../features/map';
import { ChatNavigation } from '../features/chat';
import ProtectedRoute from './ProtectedRoute';
import MainLayout from '../shared/components/MainLayout/MainLayout';


const MainNavigation = () => {

    return (
      <>
        <Routes>
          <Route path="/login/*" element={<AuthNavigation />}/>
          <Route
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
              <Route path="/ai-search/*" element={<ChatNavigation />} />
              <Route path="/" element={<MapNavigation />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />}/>
        </Routes>
      </>
    )
}

export default MainNavigation